export const environment = {
  production: true,
  MSALenabled: false,


  serviceUrl: "https://mywizardaj-saasapi.accenture.com/",
  localAPIUrl: "http://localhost:63479/",

  aiaaHomeUrl: "https://mywizardphoenixam-stage1.aiam-dh.com/IOM/",
  apHomeUrl: "https://mywizardphoenixam-stage1.aiam-dh.com/AP/opportunityTreasury",
  apBaseLineUrl: "https://mywizard-aiprojectmanager.ciostage.accenture.com/home",
  webClientID: '5b4168fb-b8dd-48fa-9c26-5fe96cf9b905',
  apiClientID: 'f1625bcc-6cd8-45ef-bea9-5d6eff6d0f5d',
  tenantID: 'e0793d39-0939-496d-b129-198edd916feb',
  authority: 'https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb/',
  azureRedirectURL: 'https://mywizardaj-saas.accenture.com',
  msalAPIurl:"https://mywizardaj-saasapi.accenture.com",

  termsOfUseUrl: "https://mywizardnextgen.ciostage.accenture.com/Views/TermsOfUse.html"
};
